import { ThemeProperties } from '../../../core';

export interface InputDateTheme {
	iconPaddingLeft: string;
	iconColor: string;
	iconSize: string;
}
export const theme = new ThemeProperties('inputDate');
